// Footer.js
import React from 'react';
import '../../styles/Footer.scss';
import { Link } from 'react-router-dom';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div data-aos="fade-in" className="address">
          <h4>Indirizzo</h4>
          <p>Via del Forno, 3</p>
          <p>63827 Pedaso (FM), Italia</p>
        </div>
        <div data-aos="fade-in" className="extra-info">
          <h4>Informazioni</h4>
          <p>Partita IVA: 02548830443</p>
          <Link to="/privacyPolicy">Privacy Policy</Link>
          <Link to="/terminiCondizioni">Termini e Condizioni</Link>
        </div>
      </div>
      <div className="footer-contacts">
        <a className='phone' href="tel:+393758872791"><PhoneIcon className="icon" /></a>
        <a className='phone' href="mailto:dinocosyhole@gmail.com"><EmailIcon className="icon" /></a>
        <a href="https://www.instagram.com/dino_cosy_hole" target="_blank" rel="noopener noreferrer"><InstagramIcon className="icon" /></a>
      </div>
    </footer>
  );
};

export default Footer;
